import React from "react";
import { StyleSheet } from "react-native";
const toXY = (point) => Array.isArray(point)
    ? { x: point[0], y: point[1] }
    : point;
const toCssAngle = (start = { x: 0.5, y: 0.0 }, end = { x: 0.5, y: 1.0 }) => {
    const s = toXY(start);
    const e = toXY(end);
    const angleRad = Math.atan2(e.x - s.x, e.y - s.y);
    const angleDeg = (angleRad * 180) / Math.PI;
    return `${angleDeg.toFixed(2)}deg`;
};
const toCssGradient = (colors, locations, angle) => {
    const stops = colors
        .map((color, i) => {
        const pct = locations ? `${(locations[i] * 100).toFixed(2)}%` : "";
        return pct ? `${color} ${pct}` : color;
    })
        .join(", ");
    return `linear-gradient(${angle}, ${stops})`;
};
const LinearGradient = ({ colors, locations, start, end, style: customStyle, className, children, testID, }) => {
    const angle = toCssAngle(start ?? undefined, end ?? undefined);
    const background = toCssGradient(colors, locations ?? null, angle);
    const flatStyle = customStyle ? StyleSheet.flatten(customStyle) : undefined;
    return (React.createElement("div", { className: className, "data-bg": background, "data-testid": testID, style: { background, ...flatStyle } }, children));
};
export { LinearGradient };
